import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, signal, TemplateRef } from '@angular/core';
import { Button } from '../button/button.component';
import { ActivatedRoute, UrlSegment } from '@angular/router';

@Component({
  selector: 'app-base-page',
  imports: [NgTemplateOutlet,Button],
  templateUrl: './base-page.component.html',
  styleUrl: './base-page.component.css',
  standalone:true
})
export class BasePageComponent {
  backUrl = signal('');
  private activatedRoute = inject(ActivatedRoute);
  @Input() templateRef!: TemplateRef<any>;
  constructor() {
    this.activatedRoute.url.subscribe((UrlSegment: UrlSegment[])=>{
      this.backUrl.set(UrlSegment[0].path);
    });
  }
}
